import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_ROUTES, Utils } from "../utils/utils";



@Injectable()
export class KpiAdminManagementService {

    constructor(
        private httpClient: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
    ) { }
    
    getKpiDefinitionList(callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/kpi_definition/FLD`;
        this.httpClient.get<any[]>(url).subscribe({
            next: response => { if (callback) callback(response); },
            error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback) errorCallback(error);
            }
        });
    }

    getKpiDimension(dimensionType: 'MovementType' | 'ProductHierarchy' | 'BreakDown', callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/kpi_dimension/${dimensionType}`;
        this.httpClient.get<any[]>(url).subscribe({
            next: response => { if (callback) callback(response); },
            error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback) errorCallback(error);
            }
        });
    }

    getKpiDefinitionReferences(callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/kpi_definition_reference/all`;
        this.httpClient.get<any[]>(url).subscribe({
            next: response => { if (callback) callback(response); },
            error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback) errorCallback(error);
            }
        });
    }

    updateKpiDefinition(kpiForm: any, callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/update_kpi_definition`;
        this.httpClient.post<any[]>(url, kpiForm).subscribe({
            next: response => { if (callback) callback(response); },
            error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback) errorCallback(error);
            }
        });
    }

    deleteKpi(kpi: any, callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/delete_kpi`;
        this.httpClient.post<any[]>(url, kpi).subscribe({
            next: response => { if (callback) callback(response); },
            error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback) errorCallback(error);
            }
        });
    }

    deleteKpiCascade(kpi: any, callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/delete_kpi_cascade`;
        this.httpClient.post<any>(url, kpi).subscribe({
            next: response => { if (callback) callback(response); },
            error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback) errorCallback(error);
            }
        });
    }

    cleanKpi(kpi: any, callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/clean_kpi`;
        this.httpClient.post<any>(url, kpi).subscribe({
            next: response => { if (callback) callback(response); },
            error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback) errorCallback(error);
            }
        });
    }

    addGroupFunctionToKpi(param: { KpiDefinitionId: number; GroupFunction: string }, callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/add_groupfunctions_to_kpi`;
        this.httpClient.post<any[]>(url, param).subscribe({
            next: response => { if (callback) callback(response); },
            error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback) errorCallback(error);
            }
        });
    }

    getKpiAccountHistory(kpiDefinitionId: number, callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_KPIMANAGEMENT}/kpiaccount/${kpiDefinitionId}/history`;
        this.httpClient.get(url).subscribe({
            next: response => {
                if (callback)
                    callback(response);
            }, error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback)
                    errorCallback(error);
            }
        }
        );
    }

    getKpiStageResultsHistory(WaveId: number, callback: any = undefined, errorCallback: any = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_BRANCHEXCELLENCE}/kpi-stage-results-history/${WaveId}`;
        this.httpClient.get(url).subscribe({
            next: response => {
                if (callback)
                    callback(response);
            }, error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback)
                    errorCallback(error);
            }
        }
        );
    }
}